<script>
    import {asyncGenToStore} from "../../area-reports/requests";
    import {getContext, tick} from "svelte";
    import {uuid} from "@manaakiwhenua/frag-svelte/src/uuid";
    import {updateReadyStore} from "@manaakiwhenua/frag-svelte/src/print-util/readyStore";
    import PointQueryKeyValueTable from "../PointQueryKeyValueTable.svelte";
    import {pullEdition1Columns} from "./edition-one-units";
    import KeyValueItem from "../KeyValueItem.svelte";

    export let request;
    export let rows = [
        'Dominant Land Use Capability Unit (national legend)',
        'Dominant LUC Class',
        'Dominant limitation to land use',
        'Additional limitation description',
        'Unit Description'
    ];

    const edition1UnitColumns = [
        "Northland",
        "Waikato",
        "Coromandel–Great Barrier",
        "Bay of Plenty–Volcanic Plateau",
        "Eastern Bay of Plenty",
        "Gisborne–East Coast",
        "Northern Hawkes Bay",
        "Wairarapa–Southern Hawke’s Bay",
        "Wellington",
        "Taranaki–Manawatu",
        "South Island (other than Marlborough)",
        "Marlborough"
    ]

    $: result = asyncGenToStore(request);

    $: edition1Row = pullEdition1Columns(edition1UnitColumns, $result);

    const readyStore = getContext('readyStore')
    const instanceId = uuid()

    $: includedRows = edition1Row
        ? [...rows, edition1Row.name]
        : rows;

    updateReadyStore(readyStore, instanceId, false);

    $: {
        if ($result) {
            tick().then(() => {
                updateReadyStore(readyStore, instanceId, true);
            })
        }
    }
</script>

{#if !$result}
    <div class="loading-spinner"></div>
{:else}
    <slot></slot>
    <PointQueryKeyValueTable data={$result}
                             {includedRows}
                             extraData={[edition1Row]} >
        {#if edition1Row}
            <KeyValueItem title={edition1Row.name}
                          value={edition1Row.value}
                          description={edition1Row.description} />
        {/if}
    </PointQueryKeyValueTable>
{/if}

<style>
    .loading-spinner { position: relative; margin: 1em; }
</style>
